const CUAL_INDIGENA = 27;

export const getPersonInfo = (values) => (
    {
        primer_nombre: values.primerNombre,
        segundo_nombre: values.segundoNombre,
        primer_apellido: values.primerApellido,
        segundo_apellido: values.segundoApellido,
        tipo_documento: values.tipoIdentificación.tipo_documento,
        numero_documento: values.numeroIdentificación,
        fecha_expedicion: values.expediciónCédula,
        fecha_nacimiento: values.fechaNacimiento,
        municipio_nacimiento: values.municipioNacimiento.id,
        sexo: values.sexo.detalle === "Masculino" ? "M" : "F",
        genero: values.genero?.id,
        genero_otro:
            values.genero?.id == 1024 ? values.genero_otro : null,
        grupo_etnico: values.grupoÉtnico.id,
        etnia_indigena:
            values.grupoÉtnico.id == 301 ? values.comunidadIndígena.id : null,
        otra_etnia_indigena:
            values.grupoÉtnico.id == 301 && values.comunidadIndígena.id == 27
                ? values.cualComunidadIndígena
                : null,
        usuario: null,
        persona: localStorage.persona_id || null,
    }
);

export const getPersonalDetail = (values) => ({
    modalidad: null,
    usted: values.tipoGestor.id,
    sector: values.sector.id,
    persona: localStorage.persona_id || null,
});

export const getResidenceInfo = (values) => ({
    persona: localStorage.persona_id || null,
    tiempo_residencia_anos: values.tiempoResidencia,
    ciudad: values?.municipioResidencia.id || null,
    area: values?.zona.id,
    localidad_rural: values?.zona.id == 223 ? values.localidad.id : null,
    barrio: values?.zona.id == 223 ? null : values?.barrio?.id,
    direccion:
        values?.zona.id == 223
            ? values.direcciónZonaRural
            : values.direcciónGenerada,
});

export const requestDetails = () => {
    const data = JSON.parse(localStorage.getItem("dataCurrentPage"));
    return {
        id: 142,
        estado_solicitud: data?.estado_solicitud,
        paso_solicitud: data?.paso_solicitud,
        label: data?.label,
        id_radicado_orfeo: data?.id_radicado_orfeo,
        fecha_solicitud: data?.fecha_solicitud,
        fecha_ultima_modificacion: data?.fecha_ultima_modificacion,
        expediente_orfeo: data?.expediente_orfeo,
        cierre: data?.cierre,
        persona: data?.persona,
    };
};
